import { render, staticRenderFns } from "./HccConfirmationFooter.vue?vue&type=template&id=45fd1a40&scoped=true&"
import script from "./HccConfirmationFooter.vue?vue&type=script&lang=js&"
export * from "./HccConfirmationFooter.vue?vue&type=script&lang=js&"
import style0 from "./HccConfirmationFooter.vue?vue&type=style&index=0&id=45fd1a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd1a40",
  null
  
)

export default component.exports